import { render, staticRenderFns } from "./NotificationList.vue?vue&type=template&id=955a635c&scoped=true&lang=pug&"
import script from "./NotificationList.vue?vue&type=script&lang=ts&"
export * from "./NotificationList.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationList.vue?vue&type=style&index=0&id=955a635c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955a635c",
  null
  
)

export default component.exports